// src/utils/firebase.js
import { initializeApp } from "firebase/app"
import { getFirestore }      from "firebase/firestore"

const firebaseConfig = {
  apiKey:    "AIzaSyDqd4SjNpbrFkBEb-fFQuTAxznyyaSAT9A",
  authDomain:"globalsavingspools.firebaseapp.com",
  projectId: "globalsavingspools",
  // …other config
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
